<template>
  <el-table-column
    :prop="column.prop"
    :key="'tbcol'+column.prop"
    :label="column.label"
    :align="column.align || 'left'"
    :width="column.width"
    :minWidth="column.minWidth"
    :sortable="column.sortable"
    :filters="column.filters"
    :filter-method="column.filterMethod"
    :filter-multiple="false"
    :render-header="column.renderHeader"
    :labelClassName="column.labelClassName"
    :show-overflow-tooltip="
      column.showTooltip !== undefined
        ? column.showTooltip
        : options.showTooltip !== undefined
        ? options.showTooltip
        : true
    "
    :fixed="column.fixed"
  >
    <template #default="scope">
      <template v-if="column.children && column.children.length">
        <r-table-column
          v-for="(child, idx) in column.children"
          :options="options"
          :key="idx"
          :column="child"
        ></r-table-column>
      </template>
      <template v-if="!column.render">
        {{ scope.row[column.prop] }}
      </template>

      <!--RenderDom-->
      <template v-else>
        <RenderDom :scope="scope" :row="scope.row" :index="scope.$index" :column="column" :render="column.render" />
      </template>

      <!--操作按钮-->
      <template v-if="column.button && column.group">
        <template v-for="(btn, i) in column.group" :key="i">
          <!--删除按钮-->
          <el-popover v-if="btn.popover" placement="top" title="确认删除吗?">
            <slot>
              <div class="r-text-popover">
                <el-button size="small" class="btn-cancel" @click="handleClosePopover($event)">取消</el-button>
                <el-button class="btn-primary" size="small" @click.stop="btn.onClick(scope.row, scope.$index)"
                  >确定</el-button
                >
              </div>
            </slot>
            <template #reference>
              <a style="padding: 1px 10px" type="text">删除</a>
            </template>
          </el-popover>
          <!--操作按钮-->
          <a class="r-operate" @click.stop="btn.onClick(scope.row, scope.$index)" v-else>
            <el-tooltip effect="dark" :content="btn.name" placement="top" :enterable="false" :key="i">
              <span>
                {{ btn.name }}
              </span>
            </el-tooltip>
          </a>
          <span class="splitline" v-if="i !== column.group.length - 1">|</span>
        </template>
      </template>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: 'RTableColumn',
  abstract: true,
  components: {
    RenderDom: {
      functional: true,
      props: {
        scope: Object,
        row: Object,
        index: Number,
        render: Function,
        column: Object
      },
      render(self) {
        const { row, index, column, scope } = self
        return self.render(row, index, column, scope)
      }
    }
  },
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleClosePopover() {
      $('body').trigger('click')
    }
  }
}
</script>

<style scoped></style>
